function LoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/html/subpage/parking/${view}.vue`
    );
}

const parkingRoutes = [
  /* 주차장 */
  // 실시간 주차현황
  {
    path: '/realtimeparking',
    name: 'realtimeparking',
    component: LoadView('realtimeParking'),
    meta: {
      category: ['주차장', '실시간 주차 현황'],
    },
  },

  // 시설안내
  {
    path: '/searchparking',
    name: 'searchparking',
    component: LoadView('searchParking'),
    meta: {
      category: ['주차장', '시설안내'],
    },
  },
  // 시설안내 - 상세
  {
    path: '/searchparkingview',
    name: 'searchparkingview',
    component: LoadView('searchParkingView'),
    meta: {
      category: ['주차장', '시설안내'],
    },
  },

  // 요금안내
  {
    path: '/parkingfeeinfo',
    name: 'parkingfeeinfo',
    component: LoadView('parkingFeeInfo'),
    meta: {
      category: ['주차장', '요금안내'],
    },
  },
  // 할인정책
  {
    path: '/parkingdiscount',
    name: 'parkingdiscount',
    component: LoadView('parkingDiscount'),
    meta: {
      category: ['주차장', '할인정책'],
    },
  },
];

export default parkingRoutes;
